/** Cookie/consent banner (`components/consent/cookie-banner.tsx`). */
export const consent = {
  dialog: {
    ariaLabel: "Cookie consent",
  },
  banner: {
    message:
      "We use essential cookies for sign-in and preferences, and optional analytics to improve OmniMedia. See our",
    privacyLink: "Privacy Policy",
    and: "and",
    cookiesLink: "Cookies",
  },
  actions: {
    rejectNonEssential: "Reject non-essential",
    acceptAll: "Accept all",
  },
} as const;
